module.exports = __webpack_public_path__ + "static/assets/fce638225be27d6825e5915996b32806.svg";